import { useIntl } from 'react-intl';

import InformationCircle from '@/assets/icons/information-circle.svg';
import { Banner } from '@/components/ui/banner';
import { useLastAutomationChannel } from '@/hooks/use-last-automation-channel';
import { BOOST, ZIPRECRUITER } from '@/types/channels';

interface ChannelCannotBePausedBannerProps {
  channelSlug: string;
  status: string;
}

export function ChannelCannotBePausedBanner({
  channelSlug,
  status,
}: ChannelCannotBePausedBannerProps) {
  const intl = useIntl();

  const lastAutomationChannel = useLastAutomationChannel();
  const lastAutomationReason =
    lastAutomationChannel?.deactivation_reason ?? null;
  const hasAutomationPausedCampaigns = lastAutomationChannel?.deactivated_at;

  /* Show banner if the channel is Boost or ZipRecruiter and the automation has paused the campaigns
  and the campaign is ongoing (active or stopped) and there is a last automation reason */
  const showBanner =
    hasAutomationPausedCampaigns &&
    (channelSlug === BOOST || channelSlug === ZIPRECRUITER) &&
    (status === 'stopped' || status === 'active') &&
    !!lastAutomationReason;

  if (!showBanner) return null;

  return (
    <Banner
      color="neutral"
      description={intl.formatMessage({
        defaultMessage:
          "This channel can't be paused once started. Once live, this campaign will continue until it ends automatically.",
        description:
          "This channel can't be paused once started. Once live, this campaign will continue until it ends automatically.",
      })}
      borderLess
      icon={<img src={InformationCircle} alt="Information" />}
      className="[&>div>p:last-child]:!text-fx-neutral-600 mx-5 mb-5"
    />
  );
}
